export default {
    setUserData(state, value) {
        state.user = value;
    },

    // 设置倒计时
    setDownTime(state, value) {
        if (value === true) value = state.unchangedDownTime;
        state.downTime = value;
    },

    setValue(state, param) {
        const key = param.key;
        if(!key) {
            return;
        }
        const keyArr = key.toString().split('.');
        let setParam = state;
        for(var i in keyArr) {
            if (i < keyArr.length - 1) {
                setParam = setParam[keyArr[i]];
            }
        }
        setParam[keyArr[keyArr.length - 1]] = param.value;
    },
    //申请是否已经提交
    setSubmitting(state, status){
        state.isSubmitting = status;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js